module.exports = __webpack_public_path__ + "img/provision-device.7d723264.svg";